import { League } from '@/entities';
import { LeagueDto } from '@/infrastructure/network/dto';

const recommendedLeagueToRecommendedLeagueDto = (teamLeagueDto: LeagueDto): League => {
	return {
		uuid: teamLeagueDto.uuid,
		playerCount: teamLeagueDto.player_count,
		isFavourite: teamLeagueDto.is_favourite,
		logo: teamLeagueDto.logo ?? { uuid: '', url: '' },
		startDatetime: teamLeagueDto.start_datetime,
		organizationUuid: teamLeagueDto.organization_uuid,
		endDatetime: teamLeagueDto.end_datetime,
		title: teamLeagueDto.title,
		location: teamLeagueDto.location
			? {
					city: teamLeagueDto.location.city,
					stateInfo: teamLeagueDto.location.state_info,
					countryInfo: teamLeagueDto.location.country_info
				}
			: null,
		isSeasonActive: teamLeagueDto.is_season_active,
		slug: teamLeagueDto.slug,
		hidePlayersCount: teamLeagueDto.hide_players_count,
		hideTeamsCount: teamLeagueDto.hide_teams_count
	};
};

export const recommendedLeaguesToRecommendedLeaguesDto = (recommendedLeagueDto: LeagueDto[]): League[] => {
	return recommendedLeagueDto.map(recommendedLeagueToRecommendedLeagueDto);
};
